import AccountApi from '../api/account-api'
import {isnull, Toast} from "./tools";
import TipsUtils from "./TipsUtils";

export default class BlockedUserUtils {

  static appIns;

  static blockedUsers = []

  static sensitiveWords = {}

  static refreshList(vueObj) {
    AccountApi.fetchBlackList(function (data, page) {
      BlockedUserUtils.assemble2Ids(data)
    }, function (code, msg, page) {
      Toast.error(TipsUtils.getErrorTips(code), page)
    }, isnull(this.appIns) ? vueObj : this.appIns)
  }

  static fetchKeyWordsList() {
    $.getJSON("https://iulia.s3.amazonaws.com/configs/sensitive_words.json").then(res => {
      res.ar = res.ar.split(" ")
      res.en = res.en.split(" ")
      res.msg_en = res.msg_en.split(" ")
      res.msg_ar = res.msg_ar.split(" ")
      BlockedUserUtils.sensitiveWords = res
    })
  }

  static isSensitiveDM(word) {
    if (isnull(word))
      return false
    let index = -1
    if (!isnull(this.sensitiveWords.ar))
      index = this.sensitiveWords.ar.indexOf(word)
    if (index < 0 && !isnull(this.sensitiveWords.en)) {
      index = this.sensitiveWords.en.indexOf(word)
    }
    return index > -1


  }

  static filterSensitiveDM(word, targetStr = '***') {
    return this.#_internalFilter(word, 1, targetStr)
  }

  static filterSensitiveLCMsg(word, targetStr = '***') {
    return this.#_internalFilter(word, 2, targetStr)
  }

  static #_internalFilter(word, type, targetStr = '***') {
    if (isnull(word))
      return ''
    let newArray = Array()
    switch (type) {
      case 1:
        newArray.push(...this.sensitiveWords.ar)
        newArray.push(...this.sensitiveWords.en)
        break;
      case 2:
        newArray.push(...this.sensitiveWords.msg_ar)
        newArray.push(...this.sensitiveWords.msg_en)
        break;
    }
    return word.replace(new RegExp(newArray.join("|"),'ig'), targetStr)
  }


  static assemble2Ids(data) {
    this.blockedUsers = []
    if (!isnull(data)) {
      for (let i = 0; i < data.length; i++) {
        let item = data[i]
        this.blockedUsers.push(item.objAccountId)
      }
    }
  }

  static hasBeenBlocked(targetAcc) {
    return !isnull(targetAcc) && this.blockedUsers.indexOf(targetAcc) > -1
  }
}



// WEBPACK FOOTER //
// ./src/utils/BlackUtils.js